/* eslint-disable */
import { useDataContext } from '../context';
import React, { useEffect, useRef } from 'react';

function AllDepartment() {
  const { data, setData } = useDataContext();
  const hasFetched = useRef(false);
  
  // 1. ดึงค่าจาก Env (Vite)
  const API_URL = import.meta.env.VITE_API_URL;

  useEffect(() => {
    // 2. เช็ค Data เดิมเพื่อไม่ให้ยิงซ้ำหากมีข้อมูลแล้ว
    if (data.docOther && data.docOther.length > 0) {
        return;
    }

    // 3. ป้องกัน StrictMode ยิงซ้ำ
    if (hasFetched.current) return;
    hasFetched.current = true;

    const controller = new AbortController(); 
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Basic SHJAYm9vbnNpcmkuY28udGg6SHJAYnNyISEh");
    
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
      signal: controller.signal
    };

    // 4. ใช้ API_URL เชื่อมกับ path /documents
    fetch(`${API_URL}/documents`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (!controller.signal.aborted) {
            setData(prevData => ({...prevData, docOther: result.data}));
        }
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
            console.error("Fetch error:", error);
        }
      });

    return () => {
        controller.abort();
    };
  }, []);

  return null;
}

export default AllDepartment;